// extracted by mini-css-extract-plugin
export default {"root":"CurrentBalance_root__c95o0","skeleton":"CurrentBalance_skeleton__yOM8b"};